import React, { useState } from 'react';
import { CardBody, Col, Form, FormGroup, Label, Row, Input } from 'reactstrap';
import Switch from "react-bootstrap-switch";
import {useForm} from "react-hook-form";
import {connect, useSelector} from "react-redux";

// labels
import {
    FL_CODE,
    FL_NAME, FL_NUMBER, FL_ONLY_REGISTERED,
    FL_ROUT,
    FL_STATUS,
} from "../../../components/i18n/formLabels";
import {PH_CODE, PH_NUMBER, PH_SEARCH_NAME} from "../../../components/i18n/placeHolders";

// actions

// components
import { ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";
import SelectGeneric from "../../../components/select/selectGeneric";

// services
import {routProvider} from "../../../providers/routProvider";
import {categoryProvider} from "../../../providers/categoryProvider";
import {getStateByPath} from "../../../redux/selectors";
import {setFilter} from "../../../redux/actions/generics/IndexedActions";
import {eventProvider} from "../../../providers/eventx/eventProvider";

function ActivityFilters(props) {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { filter, app, udn } = componentState?.data;

    const [status, setStatus] = useState(filter?.item?.status || null);
    // const [routId, setRoutId] = useState( filter?.item?.rout?.id || null );
    const [eventId, setEventId] = useState( filter?.item?.event?.id || null );
    const [categoryId, setCategoryId] = useState(filter?.item?.category?.id || null);
    const [onlyRegistered, setOnlyRegistered] = useState(true);

    const cleanFields = () => {
        setStatus(null);
        reset();
    }

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {register, handleSubmit, reset} = useForm({
    });

    const onSubmit = (data, _) => {
        if(!app?.fbDataBase?.id)
            return

        const dataFilter = {
            fbDataBase : {  id : app?.fbDataBase?.id },
            onlyRegistered : onlyRegistered,
            item : {
                ...data,
                status: status,
                udn: { id: udn?.id },
            }
        }

        // if (routId !== null)
        //     dataFilter.item.rout = { id: routId }

        if (categoryId)
            dataFilter.item.category = { id: categoryId };

        if (eventId)
            dataFilter.item.event = { id: eventId };

        props.setFilter(path, dataFilter);
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_CODE }</Label>
                            <Input type="text"
                                   name="code"
                                   placeholder={ PH_CODE }
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_NAME }</Label>
                            <Input type="text"
                                   name="name"
                                   placeholder={ PH_SEARCH_NAME }
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label >{ FL_NUMBER }</Label>
                            <Input type="number"
                                   name="number"
                                   placeholder={ PH_NUMBER }
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_STATUS }</Label>
                            <br />
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={status}
                                    innerRef={register}
                                    onChange={_ => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_ONLY_REGISTERED }</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={onlyRegistered}
                                onChange={ () => setOnlyRegistered(!onlyRegistered) }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ 'Categoria' }</Label>
                            <SelectGeneric
                                initialValue={ categoryId }
                                setExternalValue={ setCategoryId }
                                provider = { categoryProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ 'Evento' }</Label>
                            <SelectGeneric
                                initialValue={ eventId }
                                setExternalValue={ setEventId }
                                provider = { eventProvider }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(ActivityFilters)
